var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"buffer-value":100,"value":_vm.percent,"background-color":"#E5E5F0","color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }